// @flow

// Libs
import _trim from 'lodash/trim'
import _size from 'lodash/size'
import validator from 'validator'

// Constants
import {
  PROP_FARM_NAME,
  PROP_USERNAME,
  PROP_FIRST_NAME,
  PROP_LAST_NAME,
  PROP_EMAIL,
  PROP_COUNTRY,
  PROP_ADDRESS,
  PROP_POSTAL_CODE,
  PROP_CITY,
  PROP_PROVINCE,
  PROP_PHONE,
  PROP_DEFAULT_UNITS,
  PROP_PASSWORD,
  PROP_PASSWORD_CONFIRM,
  MIN_SIZE_PASSWORD,
  PROP_AREA,
} from 'hfty-model-accounts'
import { VALID_USERNAME_TEXT_PATTERN } from '../constants'

export default function validateModel (model: Object = {}): Array<{ [string]: string }> {
  model = model !== null ? model : {}
  const errors = []

  if (!_trim(model[PROP_FIRST_NAME])) {
    errors.push({key: PROP_FIRST_NAME, error: 'isRequired'})
  }
  if (!_trim(model[PROP_LAST_NAME])) {
    errors.push({key: PROP_LAST_NAME, error: 'isRequired'})
  }
  if (!_trim(model[PROP_FARM_NAME])) {
    errors.push({key: PROP_FARM_NAME, error: 'isRequired'})
  }
  if (!_trim(model[PROP_USERNAME])) {
    errors.push({key: PROP_USERNAME, error: 'isRequired'})
  }
  if (!_trim(model[PROP_COUNTRY])) {
    errors.push({key: PROP_COUNTRY, error: 'isRequired'})
  }
  if (!_trim(model[PROP_ADDRESS])) {
    errors.push({key: PROP_ADDRESS, error: 'isRequired'})
  }
  if (!_trim(model[PROP_CITY])) {
    errors.push({key: PROP_CITY, error: 'isRequired'})
  }
  if (!_trim(model[PROP_POSTAL_CODE])) {
    errors.push({key: PROP_POSTAL_CODE, error: 'isRequired'})
  }
  if (!_trim(model[PROP_PROVINCE])) {
    errors.push({key: PROP_PROVINCE, error: 'isRequired'})
  }
  if (!_trim(model[PROP_PHONE])) {
    errors.push({key: PROP_PHONE, error: 'isRequired'})
  }
  if (!_trim(model[PROP_DEFAULT_UNITS])) {
    errors.push({key: PROP_DEFAULT_UNITS, error: 'isRequired'})
  }
  if (!_trim(model[PROP_EMAIL])) {
    errors.push({key: PROP_EMAIL, error: 'isRequired'})
  }
  if (!_trim(model[PROP_PASSWORD])) {
    errors.push({key: PROP_PASSWORD, error: 'isRequired'})
  }

  if (!validator.isEmail(model[PROP_EMAIL] || '')) {
    errors.push({key: PROP_EMAIL, error: 'isInvalidEmail'})
  }
  if (!validator.isPostalCode(model[PROP_POSTAL_CODE] || '', model[PROP_COUNTRY] === 'Canada' ? 'CA' : 'US')) {
    errors.push({key: PROP_POSTAL_CODE, error: 'isInvalidZipcode'})
  }
  if (_size(model[PROP_PASSWORD]) < MIN_SIZE_PASSWORD) {
    errors.push({key: PROP_PASSWORD, error: 'passwordTooShort'})
  }
  if (model[PROP_PASSWORD] !== model[PROP_PASSWORD_CONFIRM]) {
    errors.push({key: PROP_PASSWORD, error: 'passwordsDoNotMatch'})
  }
  if (!VALID_USERNAME_TEXT_PATTERN.test(model[PROP_USERNAME])) {
    errors.push({key: PROP_USERNAME, error: 'usernameValidText'})
  }
  if (isNaN(model[PROP_AREA]) && (_size(model[PROP_AREA]))) {
    errors.push({key: PROP_AREA, error: 'digitOrBlank'})
  }
  return errors
}
